import { ValueOf } from '../utilities/types';

const questionElementTypes = {
  SELECT: 'select',
  SELECT_ARRAY: 'selectArray',
  CHECKBOX: 'checkbox',
  TEXT: 'text',
  TEXT_AREA: 'textArea',
  NUMBER: 'number',
  FILE: 'file',
} as const;

export type QuestionElementTypes = ValueOf<typeof questionElementTypes>;

export default questionElementTypes;
